import { motion } from "framer-motion";



const FoodPrep = () => {
  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }
  return (
    <motion.section
      initial="hidden"
      animate="visible"
      variants={variants}
    >
      <h4>
        <b>Important information </b>
      </h4>
      <p>
        <b>
          The application must be submitted by either the business owner or by a
          duly authorised officer on behalf of the company or incorporated body.
        </b>
      </p>
      <p>
        To help us assess your application, you need to provide following
        information:
      </p>
      <ol>
        <li className="list-none">Your business details including your ABN</li>
        <li className="list-none">Your menu or proposed menu</li>
        <li className="list-none">Kitchen or food preparation area fixture details</li>
        <li className="list-none">
          Details of existing/plan grease arrestor connection (if applicable)
        </li>
        <li className="list-none">
          Plumbing plans if you are doing a fitout or installing a new grease
          arrestor
        </li>
      </ol>
    </motion.section>
  );
};

export default FoodPrep;
